export const booleanToI18n = (value: boolean) => {
  return !!value ? {
    id: 'information.dataSet.boolean.true',
    defaultMessage: 'Yes',
    description: 'Information Popover Data Text',
  } : {
    id: 'information.dataSet.boolean.false',
    defaultMessage: 'No',
    description: 'Information Popover Data Text',
  };
}

export const emptyDateToI18n = () => {
  return {
    id: 'information.dataSet.date.empty',
    defaultMessage: 'No specified date',
    description: 'Information Popover Data Text'
  };
}

export const areaPathsToI18n = (value: boolean) => {
  return !!value ? {
    id: 'information.dataSet.areaPaths.default',
    defaultMessage: 'Default',
    description: 'Information Popover Data Text',
  } : {
    id: 'information.dataSet.areaPaths.customized',
    defaultMessage: 'Customized',
    description: 'Information Popover Data Text',
  }
}